
import { languageForCountry } from '@/utils/locales'
import { waitForPageFetches } from '@/utils/pageFetches'

export default {
  name: 'CountriesLanguagesSideBar',
  data() {
    return {
      countriesList: [],
      countriesLanguagesMap: [],
      updatingCountry: false,
      countryLanguageItem: null,
      languageCode: null,
      fullOpacityButton: false,
      shakeButton: false,
      loading: false,
    }
  },

  computed: {
    availableLocales() {
      return this.$i18n.locales
    },
  },
  mounted() {
    this.languageCode = this.$i18n.localeProperties.code
  },
  methods: {
    async onSidebarChange(visible) {
      this.fullOpacityButton = false
      if (visible && !this.countriesList.length) {
        this.loading = true
        await this.$countryService
          .fetch({ 'filter[is_allowed]': 1, limit: this.$itemsRequestLimit })
          .then(({ data }) => {
            this.countriesList = data
            this.mapCountriesToLanguages()
          })
        this.loading = false
      }
    },
    setCountryLanguageItem(countryId) {
      this.countryLanguageItem = this.countriesLanguagesMap.find(
        item => item.country_id === countryId
      )
      this.fullOpacityButton = true
    },
    setLanguageCode(languageCode) {
      if (this.countryLanguageItem) {
        this.countryLanguageItem.language_code = languageCode
      }
      this.languageCode = languageCode
      this.fullOpacityButton = true
      this.shakeValidateButton()
    },
    shakeValidateButton() {
      this.shakeButton = false
      this.$nextTick(() => {
        this.shakeButton = true
      })
    },
    mapCountriesToLanguages() {
      this.countriesList.forEach(country => {
        this.countriesLanguagesMap.push({
          country_id: country.id,
          country_iso: country.iso,
          language_code: languageForCountry(country.iso),
        })
      })
    },

    async onSubmit() {
      this.updatingCountry = true
      if (
        this.$auth.loggedIn &&
        !this.$store.getters.is_pro &&
        this.countryLanguageItem
      ) {
        await this.$userService
          .update(this.$auth.user.id, {
            country_id: this.countryLanguageItem.country_id,
          })
          .then(() => {
            this.$auth.fetchUser()
          })
          .catch(error => {
            this.$swalErrorMessage(error)
          })
      }

      const targetLanguageCode = this.countryLanguageItem
        ? this.countryLanguageItem.language_code
        : this.languageCode
      await waitForPageFetches(this.$nuxt)
      const alternateUrls = this.$store.state.alternate_urls || {}
      const restrictedLocales = this.$store.state.restricted_locales || []
      const targetUrl = restrictedLocales.includes(targetLanguageCode)
        ? this.localePath({ name: 'index' }, targetLanguageCode)
        : alternateUrls[targetLanguageCode] ||
          this.switchLocalePath(targetLanguageCode)
      await this.$i18n.setLocaleCookie(targetLanguageCode)
      window.location.href = targetUrl
    },
  },
}
